// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style__split_page___36Ext{display:flex}.style__split_page___36Ext .style__container___1zPGi{flex-grow:1;padding:0 25px}\n", "",{"version":3,"sources":["webpack://./src/app/common/SplitPage/style.scss"],"names":[],"mappings":"AAAA,2BACE,YAAa,CADf,qDAII,WAAY,CACZ,cAAe","sourcesContent":[".split_page {\n  display: flex;\n\n  .container {\n    flex-grow: 1;\n    padding: 0 25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"split_page": "style__split_page___36Ext",
	"container": "style__container___1zPGi"
};
export default ___CSS_LOADER_EXPORT___;
